<template>
  <div>
    <a-row class="mb-20" style="margin-bottom: 20px">
      <a-col :xs="24" :sm="24" :md="8">
        <a-input-search
          style="width: 100%"
          :placeholder="$t('categoryManager.search')"
          enter-button
          @search="onSearch"
        />
      </a-col>
      <!-- <a-col :xs="24" :sm="24" :md="{span: 4, offset: 2}">
        <a-select
          style="width: 100%"
          placeholder="Vai trò"
        >
          <a-select-option value="true">
            Admin
          </a-select-option>
          <a-select-option value="false">
            Sale
          </a-select-option>
        </a-select>
      </a-col> -->
      <a-col :xs="24" :sm="24" :md="{span: 2, offset: 13}">
        <a-button type="primary" icon="plus" @click="handleCreate">
          {{ $t('table.create') }}
        </a-button>
      </a-col>
    </a-row>
    <a-divider />
    <a-row>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="record">
          <a-button type="primary" icon="form" size="small" @click="handleEdit(record)">{{ $t('table.update') }}</a-button>
          <a-divider type="vertical" />
          <a-button type="danger" icon="delete" size="small" @click="confirmDelete(record)">{{ $t('table.delete') }}</a-button>
        </span>
      </a-table>
    </a-row>
    <AddEditModal ref="refModal" @updateCategorySuccess="handleUpdateCategorySuccess" />
  </div>
</template>

<script>
import {
  SearchCategory as ApiSearchCategory,
  DestroyCategory as ApiDestroyCategory
} from '@/api/categories';
import AddEditModal from './AddEditModal.vue';

export default {
  name: 'Category',
  components: {
    AddEditModal
  },
  data() {
    const columns = [
      {
        dataIndex: 'name',
        title: () => this.$t('categoryManager.column.name'),
        key: 'name'
      },
      {
        dataIndex: 'description',
        title: () => this.$t('categoryManager.column.description'),
        key: 'description'
      },
      {
        dataIndex: 'icon',
        title: () => this.$t('categoryManager.column.icon'),
        key: 'icon',
        customRender: (value, row, index) => {
          return <img width='30px' height='30px' src={`${row.base_url}${row.icon.url}`}/>;
        }
      },
      {
        title: this.$t('table.action'),
        key: 'action',
        width: '200px',
        scopedSlots: { customRender: 'action' }
      }
    ];
    return {
      columns,
      data: [],
      pagination: { current: 1, pageSize: 15 },
      filter: {},
      params: {},
      loading: false,
      form: this.$form.createForm(this)
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    onSearch(value) {
      this.filter.name = value;
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.params.filter = this.filter || {};
      this.params.page = this.pagination.current || 1;
      ApiSearchCategory(this.params)
        .then((response) => {
          const { data, pagination } = response;
          this.data = data;
          this.pagination = {
            total: pagination.total,
            pageSize: pagination.perPage,
            current: pagination.currentPage
          };
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.handleSearch();
    },
    handleCreate() {
      this.$refs.refModal.showModal();
    },
    handleEdit(row) {
      this.$refs.refModal.showModal(row.id);
    },
    handleUpdateCategorySuccess() {
      this.handleSearch();
    },
    confirmDelete(record) {
      this.$confirm({
        title: this.$t('modal.confirmDelete.question'),
        okText: this.$t('modal.confirmDelete.ok'),
        cancelText: this.$t('modal.confirmDelete.cancel'),
        onOk: () => {
          const { id } = record;
          ApiDestroyCategory({ id })
            .then(() => {
              this.$notification.success({ message: this.$t('modal.successMessage.deleteSuccess') });
              this.searchCategory();
            })
            .catch(() => {
              this.$notification.error({ message: this.$t('modal.faildMessage.deleteFaild') });
            });
        }
      });
    }
  }
};
</script>
